import { useLocation } from "react-router-dom";
import QueryString from "query-string";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useInstagramLoginCore } from "../../../../cores/instagramLogin";
import { useMeCore } from "../../../../cores/me";
import { useRouterCore } from "../../../../cores/router";

const OAUTH_MESSAGE_FROM = "Instagram Login";

export default function InstagramLoginPopUp() {
  const intl = useIntl();
  const { search } = useLocation();
  const { bind } = useInstagramLoginCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { goToBinding } = useRouterCore();

  useEffect(() => {
    const params = QueryString.parse(search);
    const { code, state, error, error_description: errorDescription } = params;

    if (window.opener) {
      if (error) {
        window.opener.postMessage(
          {
            error,
            errorMessage:
              (errorDescription as string) ||
              intl.formatMessage({ id: "app.instagramLogin.toast.error" }),
            from: OAUTH_MESSAGE_FROM,
          },
          window.location.origin
        );
        window.close();
        return;
      }

      if (code) {
        window.opener.postMessage(
          { code, state, from: OAUTH_MESSAGE_FROM },
          window.location.origin
        );
        window.close();
      }
      return;
    }

    if (code && company?.id) {
      bind(String(company.id), code as string, () => {
        getMeSocialSettings(company.id);
        goToBinding();
      }, state as string | undefined);
    }
  }, [
    search,
    company,
    bind,
    goToBinding,
    getMeSocialSettings,
    intl,
  ]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <p className="text-muted mb-0">
        {intl.formatMessage({ id: "app.instagramLogin.popup.connecting" })}
      </p>
    </div>
  );
}
